import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroBullets } from '../data/content';
export function Hero() {
  return <section className="w-full bg-ink-black" data-id="element-84" data-mp="9k0fha3kwjqp">
      <div className="mx-auto flex max-w-5xl flex-col items-center px-5 py-9 text-center sm:px-6 sm:py-14" data-id="element-85" data-mp="9ipaj6yed5y0">
        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display max-w-3xl text-[1.85rem] leading-[1.02] text-white sm:text-5xl lg:text-6xl" data-id="element-86" data-mp="4jvvha3gp6vq">
          Toma el control total de tu gestión y profesionaliza tu Airbnb en solo{' '}
          <span className="text-brand" data-id="element-87" data-mp="nbosdflnjc8q">7 días</span>.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-4 max-w-2xl text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-88" data-mp="3d2labedjz91r">
          Domina el Sistema Operativo de gestión técnica diseñado para
          profesionalizar tu Airbnb y recuperar tu libertad.
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} src="https://cdn.magicpatterns.com/uploads/4bVSi7CNNHW9oTqF4arNSV/ChatGPT_Image_22_ago_2026,_03_08_17.png" alt="Sistema Anfitrión Pro 365 en laptop, tablet y celular junto a las guías, plantillas de mensajes y listas de verificación" className="mt-7 w-full max-w-4xl" width={1536} height={1024} data-id="element-89" data-mp="39a37n0wwdfnb" />

        <div className="mt-7 w-full max-w-md" data-id="element-90" data-mp="2hinawe1mmcjd">
          <CTAButton label="Sí, quiero ser un Anfitrión Pro" size="lg" fullWidth data-id="element-91" data-mp="2hjyot6osd0o7" />
          <p className="mt-3 text-xs font-semibold text-white/60" data-id="element-92" data-mp="2ljgzzaqt1xdu">
            Acceso inmediato · Pago único · Garantía de 7 días
          </p>
        </div>

        <ul className="mt-8 grid w-full max-w-3xl grid-cols-1 gap-x-8 gap-y-2 text-left sm:grid-cols-2" data-id="element-93" data-mp="nbl2il2gggag">
          {heroBullets.map(bullet => <li key={bullet} className="flex items-start gap-2" data-id="element-94" data-mp="icrngo7ish86">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success-light" strokeWidth={3} aria-hidden="true" data-id="element-95" data-mp="ddwx91783qe1" />
              <span className="text-[13px] font-medium leading-snug text-white/80 sm:text-sm" data-id="element-96" data-mp="1622irq63pjex">
                {bullet}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}